// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1ADBa","description":"PatientConsentPreview_description__1Kosy"};